import { useEffect } from 'react';

import { useCsvDownloadSetters } from '@/components/Chart/context/CsvTableContext';

type UseCsvDownloadOptions = {
  fileName?: string;
  groupName?: string;
  dateColumnKey?: string | null;
};

const useCsvDownload = (
  from: string | undefined,
  downloadFileId: string | undefined,
  options?: UseCsvDownloadOptions
) => {
  const { fileName, groupName, dateColumnKey } = options ?? {};
  const { setDownloadFileId, setSelectedRange, setFileName, setGroupName, setDateColumnKey } =
    useCsvDownloadSetters();

  useEffect(() => {
    setDownloadFileId(downloadFileId);
    setSelectedRange(downloadFileId && from && from.length > 0 ? from : undefined);
  }, [from, downloadFileId, setDownloadFileId, setSelectedRange]);

  useEffect(() => {
    setFileName(fileName);
  }, [fileName, setFileName]);

  useEffect(() => {
    setGroupName(groupName);
  }, [groupName, setGroupName]);

  useEffect(() => {
    setDateColumnKey(dateColumnKey);
  }, [dateColumnKey, setDateColumnKey]);

  return {};
};

export default useCsvDownload;
